import { useCallback, useMemo } from 'react';
import { merge } from 'lodash';
import type { UserPrefs } from '@frameio/graphql-client/generated';
import {
  useGetUserPrefsQuery,
  useSetUserPrefsMutation,
} from '@frameio/graphql-client/generated';
import { useCurrentPageType } from '../routing';

type UseUserPrefsProps = {
  userId?: string;
};

export const useUserPrefs = (props: UseUserPrefsProps = {}) => {
  const { userId } = props;
  const pageType = useCurrentPageType();

  /**
   * @see VIEW-2987
   */
  const defaultId =
    pageType === 'shareReviewReel' ? 'default-share-user' : 'default-user';
  const { data } = useGetUserPrefsQuery({
    variables: { userId: userId || defaultId },
  });

  const userPrefs = useMemo(
    () => data?.getUserPrefs || ({} as UserPrefs),
    [data?.getUserPrefs]
  );

  const [_setUserPrefs] = useSetUserPrefsMutation();

  const setUserPrefs = useCallback(
    (s: any) => {
      _setUserPrefs({
        variables: {
          userId: userId || defaultId,
          userPrefs: merge({}, userPrefs, s),
        },
      });
    },
    [_setUserPrefs, defaultId, userId, userPrefs]
  );

  return {
    userPrefs,
    setUserPrefs,
  };
};
